import { render, staticRenderFns } from "./ButtonSwitch.vue?vue&type=template&id=97fd9ae8"
import script from "./ButtonSwitch.vue?vue&type=script&lang=js"
export * from "./ButtonSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports